module.exports = __webpack_public_path__ + "static/media/memberIcon.6527e6c1.svg";